<template>
    <div class="overview" v-if="this.allMessages.length || this.watchedMessages.length">
        <aside class="overview__sidebar sidebar" id="people-list">
            <div class="sidebar__item activechats" v-if="this.allMessages.length">
                <h3 class="sidebar__headline" v-if="this.allMessages.length"> Chats in Bearbeitung:</h3>
                <ul class="sidebar__list inprocess">
                    <li class="sidebar__list-item" ref="listItems"
                        :class="{ active: isActive(chat) }"
                        v-for="(chat, index) in allMessages" v-on:click="openChat(chat, index ,'processed', false)"
                        :key="chat.id">
                        <div class="about">
                            <div class="name">
                                <p>{{chat.fullCustomerName}}</p></div>
                            <div class="status" v-if="chat.status === 'processed'">
                                <i class="fa fa-circle online"></i>
                                <p>in Bearbeitung</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="sidebar__item watchedchats" v-if="this.watchedMessages.length">
                <h3 class="sidebar__headline" v-if="this.watchedMessages.length">Beobachtungsliste:</h3>
                <ul class="sidebar__list watched">
                    <li class="sidebar__list-item" v-on:click="openChat(chat,index, 'watched' ,true)"
                        v-bind:class="{ active: isActive(chat) }" v-for="(chat, index) in watchedMessages"
                        :key="chat.id">
                        <div class="about">
                            <div class="name">
                                <p>{{chat.fullCustomerName}}</p></div>
                            <div class="status">
                                <i class="fa fa-circle watched"></i>wird beobachtet
                            </div>
                        </div>
                    </li>
                </ul>

            </div>

        </aside>

        <main class="overview__main">
            <div class="chat" v-if="currentChat">
                <div class="chat__header">
                    <div class="chat__info">
                        <div class="chat-about">
                            <div class="chat-with">
                                <p>{{currentChat.fullCustomerName}}</p>
                                <a target="_blank" :href="'/backend/customers/' + getUnhashedCustomerId(currentChat)"><i
                                        class="fa fa-info-circle"></i></a>
                            </div>
                            <div class="customerTyping" v-if="this.customerIsTyping">
                                <i class="fa fa-comments-o" aria-hidden="true"></i>
                                <p>Kunde tippt ...</p>
                            </div>
                        </div>
                    </div>
                    <div class="chat__actions">
                        <ActionsSingleChat @reset="setInitalChat" @error="setError" @success="setSuccess" v-if="!isObserved"
                                           :current-chat="currentChat"></ActionsSingleChat>
                        <ActionsObservedSingleChat @reset="setInitalChat" @error="setError" @success="setSuccess" :user-id="userId"
                                                   :current-chat="currentChat" v-if="isObserved"></ActionsObservedSingleChat>
                    </div>
                </div> <!-- end chat__header -->
                <div class="messages" v-chat-scroll="{always: false, smooth: false}">
                    <div class="chat-history">
                        <div v-if="currentChat.messages && !currentChat.messages.length">In diesem Chat existieren bisher noch keine
                            Nachrichten.
                        </div>
                        <Message v-for="message in currentChat.messages" :key="message.id" @error="setError"
                                 @success="setSuccess" :message="message"
                                 :currentChat="currentChat"></Message>
                    </div>
                </div>
                <div class="chat__send">
                    <CreateMessage @error="setError" @success="setSuccess" v-if="!isObserved"
                                   :chatTemplates="chatTemplates"
                                   :currentChat="currentChat"></CreateMessage>
                </div> <!-- end chat-message -->

            </div> <!-- end chat -->
        </main>

    </div>

</template>

<script>
    import CreateMessage from "../components/CreateMessage";
    import Message from "../components/Message"
    import ActionsSingleChat from "./ActionsSingleChat";
    import ActionsObservedSingleChat from "./ActionsObservedSingleChat";
    import Hashids from 'hashids';
    import {collection, getDocs, onSnapshot, query, doc} from "firebase/firestore";

    export default {
        name: 'ChatsOverviewUser',
        props: ['chatTemplates', 'userId'],
        components: {
            CreateMessage,
            Message,
            ActionsSingleChat,
            ActionsObservedSingleChat,
        },
        data() {
            return {
                isObserved: false,
                unhashedCostumerId: null,
                customerIsTyping: false,
                currentChatIndex: 0,
                currentChatState: "processed",
                currentChat: null,
                customerIsTypingUnsubscribe: null,
                currentChatUnsubscribe: null,
            }
        },
        computed: {
          watchedMessages: function () {
             return this.$store.getters.getAllWatchedMessagesByChatAgent;
          },
          allMessages: function () {
            return this.$store.getters.getAllChatAgentMessages;
          }
        },
        methods: {
            isActive: function (chat) {
                return (chat && this.currentChat && chat.customerId === this.currentChat.customerId);

            },
            setInitalChat: function () {
              if(this.allMessages.length) {
                this.openChat(this.allMessages[0], 0, 'processed', false);
              } else if (this.watchedMessages.length) {
                this.openChat(this.watchedMessages[0], 0, 'watched', true);
              }
            },
            openChat: function (chat, index, currentChatState, isObserved) {
              if (this.currentChatUnsubscribe && this.currentChatUnsubscribe ) {
                this.currentChatUnsubscribe();
                this.customerIsTypingUnsubscribe();
              }
              this.currentChat = chat;
              this.currentChatIndex = index;
              this.currentChatState = currentChatState;
              this.isObserved = isObserved;
              const basePath = this.currentChat.clientId.toString() + '/' + this.currentChat.customerId.toString();
              const messageCollection = collection(this.$store.getters.getFireStore.store, basePath + '/messages');
              const customerIsTypingDocument = doc(this.$store.getters.getFireStore.store, basePath + '/highRefreshChatInfos/customerIsTyping');

              this.customerIsTypingUnsubscribe = onSnapshot(customerIsTypingDocument, async (doc) => {
                this.customerIsTyping = doc.data().customerIsTyping;
              });

              const q = query(messageCollection);
              this.currentChatUnsubscribe = onSnapshot(q, async (querySnapshot) => {
                this.$set(this.currentChat, 'messages',querySnapshot.docs.map(doc => doc.data()).sort((a,b) => a.timestamp - b.timestamp));
              });
            },

            getUnhashedCustomerId: function (currentchat) {
                const hashids = new Hashids('l9tvc287z3gkuwfx3g', 32, 'abcdefghijklmnopqrstuvwxyz1234567890');
                return hashids.decode(currentchat.customerId)[0];
            },
            setError: function (msg) {
                this.$emit('error', msg)
            },
            setSuccess: function (msg) {
                this.$emit('success', msg)
            }
        },
        updated() {
          if (!this.currentChat) {
            this.setInitalChat();
          }
        }
    }
</script>

<style lang="scss">

    $green: #86BB71;
    $blue: #94C2ED;
    $orange: #E38968;
    $gray: #92959E;

    *, *:before, *:after {
        box-sizing: border-box;
    }

    .sidebar {

        display: flex;
        flex-direction: column;
        margin-bottom: 15px;

        &__item {
            max-height: 100%;
            flex-shrink: 1;
            flex-grow: 1;
            overflow: hidden;

            &:hover {
                overflow-y: scroll;
            }

            &.watchedchats {
                &:before {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 5%;
                    width: 90%;
                    height: 2px;
                    background-color: red;
                }
            }

            &.activechats {
                &:before {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 5%;
                    width: 90%;
                    height: 2px;
                    background-color: red;
                }
            }

        }

        &__headline {
            padding: 25px 0 25px 23px;
            color: #ebebeb;
            background-color: #304050;
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            border-bottom: 1px solid #fff;
        }

        &__list {
            &.inprocess {
                margin-bottom: 45px;

                ::-webkit-scrollbar {
                    width: 4px;
                    width: 4px;
                    border-radius: 7px;
                    height: 10px;
                    background: transparent; /* Optional: just make scrollbar invisible */
                }

                /* Optional: show position indicator in red */
                ::-webkit-scrollbar-thumb {
                    background: #FF0000;
                }
            }

            &.watched {

            }

            max-height: 100%;
            overflow-y: hidden;
            padding: 0 0 50px 0;
            list-style-type: none;
        }

        &__list-item {
            cursor: pointer;
            margin: 10px 0;
            min-height: 60px;

            &:first-of-type {
                margin-top: 0;
            }

            &.active {
                background-color: #2a3845;
                border-left: 6px solid #42B886;

                &:hover {
                    border-left: 6px solid #42B886;
                }
            }

            &:hover {
                border-left: 4px solid #42B886;
            }
        }

        input {
            border-radius: 3px;
            border: none;
            padding: 14px;
            color: white;
            background: #6A6C75;
            width: 90%;
            font-size: 14px;
        }

        .fa-search {
            position: relative;
            left: -25px;
        }

        img {
            float: left;
        }

        .about {
            display: flex;
            flex-direction: column;
            padding-top: 4px;
            padding-left: 8px;
            margin-left: 15px;
            font-color: #fff;

            .name {
                p {
                    color: #fff;
                }
            }
        }

        .status {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            color: #fff;

            p {
                margin: 0;
            }
        }
    }

    .overview {
        padding: 40px 20px 40px 20px;
        width: 100%;
        background: #ebebeb;
        border-radius: 7px;
        display: flex;

        &__sidebar {
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
            background-color: #304050;
            width: 260px;
            flex-shrink: 0;
            flex-grow: 0;
            max-height: 750px;
            min-height: 750px;
            overflow: hidden;
        }

        &__main {
            flex-grow: 1;
            border-radius: 7px;
            max-height: 100%;
            overflow: hidden;
        }
    }

    .chat {
        background: #F2F5F8;
        border-radius: 7px;
        color: #2F4051;
        max-width: 800px;
        max-height: 750px;
        min-height: 750px;

        &__header {
            padding: 0 20px 0 20px;
            border-bottom: 2px solid #ebebeb;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background-color: #fff;

            .chat-about {
                float: left;
                padding-left: 10px;
                margin-top: 6px;
                display: flex;
                align-items: center;

                p {
                    margin: 0
                }

                a {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                }

                .customerTyping {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    width: 150px;
                    padding: 5px 5px 5px 5px;
                    color: #fff;
                    border-radius: 7px;
                    background-color: #42B886;

                    p {
                        margin: 0
                    }
                }
            }

            .chat-with {
                display: flex;
                font-weight: bold;
                font-size: 16px;

                i {
                    margin-left: 5px;
                    color: #1E64FF;
                }
            }

            .chat-num-messages {
                color: $gray;
            }

            .fa-star {
                float: right;
                color: #D8DADF;
                font-size: 20px;
                margin-top: 12px;
            }

        }

        &__info {
            flex-grow: 1;
            display: flex;
            align-items: center;
        }

        .messages {
            padding: 0 30px 20px;
            overflow-y: scroll;
            background-color: #fff;

            ::-webkit-scrollbar {
                border-radius: 7px;
                background: transparent; /* Optional: just make scrollbar invisible */
            }
        }

        &__send {
            padding: 30px 30px 30px 30px;

            textarea {
                width: 100%;
                border: none;
                padding: 10px 20px;
                font: 14px/22px "Lato", Arial, sans-serif;
                margin-bottom: 10px;
                border-radius: 5px;
                resize: none;

            }

            .fa-file-o, .fa-file-image-o {
                font-size: 16px;
                color: #1E64FF;
                cursor: pointer;

            }

            button {
                float: right;
                color: #1E64FF;
                font-size: 16px;
                text-transform: uppercase;
                border: none;
                cursor: pointer;
                font-weight: bold;
                background: #F2F5F8;

                &:hover {
                    color: darken($blue, 7%);
                }
            }
        }
    }

    .online, .offline, .me {
        margin-right: 3px;
        font-size: 10px;
    }

    .online {
        color: $green;
    }

    .watched {
        &.fa {
            color: #e6e627;
            font-size: 10px;
        }

    }

    .offline {
        color: $orange;
    }

    .me {
        color: $blue;
    }

    .align-left {
        justify-content: flex-start;
    }

    .align-right {
        margin-right: 4px;
        justify-content: flex-end;
    }

    .float-right {
        float: right;
    }

    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .messages {
        padding-top: 25px;
        overflow: auto;
        height: 440px;
    }

    @-webkit-keyframes mover {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(-5px);
        }
    }

    @keyframes mover {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(-5px);
        }
    }

    .singleChatActions {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .scrolly {
        ::-webkit-scrollbar {
            width: 4px;
            border-radius: 7px;
            height: 10px;
            background: transparent; /* Optional: just make scrollbar invisible */
        }

        /* Optional: show position indicator in red */
        ::-webkit-scrollbar-thumb {
            background: #FF0000;
        }
    }

    ::-webkit-scrollbar {
        background: transparent; /* Optional: just make scrollbar invisible */
        width: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background: #fff;
        border-radius: 7px;
        height: 5px;
    }


</style>
